// Stub AI slice for PWP - ProphetAI features are not available in PWP
import { createSlice } from '@reduxjs/toolkit';

const aiSlice = createSlice({
    name: 'ai',
    initialState: {
        game: null,
        drawerView: null,
    },
    reducers: {
        setGame(state, action) {
            state.game = action.payload;
        },
        setDrawerView(state, action) {
            state.drawerView = action.payload;
        },
        initPropFinderWithGame() {
            // No-op in PWP - PropFinder not available
        },
        fetchGameChatResponse() {
            // No-op in PWP - ProphetAI not available
        },
    },
});

export const { setGame, setDrawerView, initPropFinderWithGame, fetchGameChatResponse } = aiSlice.actions;
export default aiSlice.reducer;
